import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconMap = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconMap",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m574-129-214-75-186 72q-10 4-19 3t-18-7-12-13-5-20v-561q0-13 8-23t20-15l186-63 13-3 13-1 14 1 12 3 214 75 186-72q10-4 20-2t17 6 13 14 4 19v561q0 13-7 23t-21 15l-186 63-12 3-14 1-13-1zm-14-89v-468l-160-56v468z"
  })
}));